import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=0dc75c62&scoped=true&lang=pug&"
import script from "./ProductSearch.vue?vue&type=script&lang=ts&"
export * from "./ProductSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=0dc75c62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc75c62",
  null
  
)

export default component.exports